import { useConfigStore } from '@/store/config.store';
import { useTemplateStore } from '@/store/template.store';
import { getEmptyImageField } from '@/utils/emptyTemplate';
import { GRADUATION_NAME } from '@/littleWedding/projectConstantes';
import { EGobeletType } from '@/littleWedding/EGobeletType';
import { dataStore } from '@/commons/DataStore';
import { storeToRefs } from 'pinia';
import { computed, ref } from 'vue';
import type { IImageField } from '@/typescript/interfaces/IImageField';

interface GraduationPosition {
    x: number;
    y: number;
}

const savedGraduationPosition = ref<GraduationPosition | null>(null);

export function useGraduation() {
    const templateStore = useTemplateStore();
    const { currentSide, productType } = storeToRefs(useConfigStore());
    const { selectedTemplate } = storeToRefs(templateStore);

    function toggleGraduation() {
        const graduationField = findGraduationField();

        if (graduationField) {
            const fabricWorld = dataStore.getFabricWorld(currentSide.value);
            const fabricObject = fabricWorld.getFabricElementById(graduationField.id);
            if (fabricObject) {
                savedGraduationPosition.value = {
                    x: fabricObject.left || 0,
                    y: fabricObject.top || 0,
                };
            } else if (graduationField.transform?.position) {
                savedGraduationPosition.value = graduationField.transform.position;
            } else {
                savedGraduationPosition.value = null;
            }

            templateStore.removeField(graduationField);
        } else {
            const newImageField = getEmptyImageField();
            newImageField.filename = GRADUATION_NAME;
            newImageField.url = productType.value === EGobeletType.SMALL ? '/images/graduation_33.png' : '/images/graduation_50.png';

            if (savedGraduationPosition.value) {
                newImageField.transform = {
                    ...newImageField.transform,
                    position: { ...savedGraduationPosition.value },
                };
            }

            templateStore.addField(newImageField);
        }
    }

    function findGraduationField() {
        return selectedTemplate.value.configuration.fields.find((field) => {
            if (!('filename' in field)) {
                return false;
            }
            return (field as IImageField).filename === GRADUATION_NAME;
        });
    }

    const hasGraduation = computed(() => !!findGraduationField());

    return {
        toggleGraduation,
        hasGraduation,
    };
}
